export default "__VITE_ASSET__XsDTRUaO__"